<template>
    <div class="customer-default-speakers-repeater">
        <div class="customer-default-speakers-repeater__items">
            <transition-group name="fade-down">
                <CustomerDefaultSpeakersForm
                    v-for="(item, index) in modelValue"
                    :key="index"
                    v-model="customerDefaultSpeakers[index]"
                    :schema="schema"
                    :book-languages="bookLanguages"
                    :default-speakers="modelValue"
                    :can-delete="customerDefaultSpeakers.length > 0"
                    @delete="onDelete"
                />
            </transition-group>
        </div>
        <button :class="['button', 'button--fullwidth']" type="button" @click="addDefaultSpeaker">
            + Add speaker
        </button>
    </div>
</template>

<script>
import CustomerDefaultSpeakersForm from '../CustomerDefaultSpeakersForm/CustomerDefaultSpeakersForm';
export default {
    name: 'CustomerDefaultSpeakersRepeater',
    components: {
        CustomerDefaultSpeakersForm,
    },
    props: {
        schema: {
            type: Object,
            required: true,
        },
        bookLanguages: {
            type: Array,
            default: () => [],
        },
        modelValue: {
            type: Array,
            default: () => [],
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            customerDefaultSpeakers: [],
            initialDefaultSpeakers: {
                language: undefined,
                speaker: undefined,
            },
        };
    },
    watch: {
        customerDefaultSpeakers: {
            deep: true,
            handler() {
                this.update(this.customerDefaultSpeakers);
            },
        },
    },

    methods: {
        addDefaultSpeaker() {
            this.customerDefaultSpeakers.push({ ...this.initialDefaultSpeakers });
        },
        update(event) {
            this.$emit('update:modelValue', event);
        },
        onDelete(event) {
            this.customerDefaultSpeakers.splice(this.customerDefaultSpeakers.indexOf(event), 1);
        },
    },
};
</script>

<style lang="scss" src="./CustomerDefaultSpeakersRepeater.scss"></style>
